import React from 'react';

export const useDelay = (delay: number, onTimeout: () => void) => {
  React.useEffect(() => {
    const timer = setTimeout(onTimeout, delay);
    return () => clearTimeout(timer);
  }, [delay, onTimeout]);
};
